import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

export type UniformDividerProps = {
	lineStyle?: 'solid' | 'dotted';
	orientation?: 'horizontal' | 'vertical';
};

const dividerStyle = css({
	border: 'none',
	margin: 0,
});

const horizontalStyle = css({
	width: '100%',
});

const verticalStyle = css({
	width: 0,
	height: 'auto',
	alignSelf: 'stretch',
});

const UniformDivider = ({
	lineStyle = 'solid',
	orientation = 'horizontal',
}: UniformDividerProps) => {
	const isVertical = orientation === 'vertical';
	const border = `1px ${lineStyle} ${wacToken('color.neutral.light400')}`;

	return (
		<hr
			css={[dividerStyle, isVertical ? verticalStyle : horizontalStyle]}
			role="presentation"
			style={isVertical ? { borderInlineStart: border } : { borderBlockStart: border }}
		/>
	);
};

export default UniformDivider;
